import React from "react"
import styled from "styled-components/macro"

interface Props {
  children?: React.ReactNode
  className?: string
}

export const PCScreen = (props: Props): JSX.Element => {
  return <S_PCScreen className={props.className}>{props.children}</S_PCScreen>
}

const S_PCScreen = styled.div`
  display: flex;
  margin: auto;
  width: 100%;
  @media only screen and (min-width: 1260px) {
    margin: auto;
    width: 1260px;
  }
`
